import { createAsyncThunk } from '@reduxjs/toolkit';
import getBulletins from 'scenes/BulletinBoard/utils/getBulletins';
import getCredentials from '../../utils/getCredentials';

/**
 * Re-read one project's bulletins into the store, without disturbing the view.
 *
 * ## Why not `loadInitialBulletinData`
 *
 * Two reasons, and the first is the one that would be noticed. Its `pending`
 * case sets `state.loading`, which the board renders by replacing the whole
 * list with a spinner — fine on mount, wrong for a background refresh, because
 * the user is reading the list at the time. The second is cost: it also fetches
 * the project, the employer project, the default file permissions, and two file
 * permissions *per bulletin*, none of which a new or edited row changes.
 *
 * ## Why a refetch rather than the row itself
 *
 * The server knows exactly what it wrote and could send it. Taking it would
 * mean trusting a shape assembled somewhere else and keeping the two in step
 * forever; one extra GET buys the board's own idea of its data instead.
 *
 * Dispatched whether or not the board is mounted — the result lands in the
 * store either way, so the list is already right when the user arrives at it.
 */
export const refreshBulletins = createAsyncThunk(
  'bulletinBoard/refreshBulletins',
  async (projectId) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const bulletins = await getBulletins(projectId, {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    });

    return Array.isArray(bulletins) ? bulletins : [];
  }
);

export default refreshBulletins;
